import { useSiteContext } from '../../../../../state';
import { SiteSettingsProvider } from '../SiteSettingsContext';
import { SiteSettingsHeader } from '../SiteSettingsHeader';
import { SitePickAIModePanel } from './SiteAIModePanel';
import { SiteEmbedPanel } from './SiteEmbedPanel';
import { SiteMcpServersPanel } from './SiteMcpServersPanel';

export function SiteAISettings() {
    const { organizationId, site } = useSiteContext();

    return (
        <>
            <SiteSettingsHeader
                headingId="redirects"
                heading="AI & MCP"
                description="Empower your site visitors to ask questions and get answers using AI search, and
                    extend its capabilities with MCP connectors."
            />
            <SiteSettingsProvider organizationId={organizationId} site={site}>
                <SitePickAIModePanel />
                <SiteMcpServersPanel />
                <SiteEmbedPanel />
            </SiteSettingsProvider>
        </>
    );
}
